import styled, { css } from 'styled-components';

export const Container = styled.div<{ height: string; hasMinHeight?: boolean }>`
  ${({ height, hasMinHeight }) => css`
    height: ${height};
    ${hasMinHeight &&
    css`
      min-height: ${height};
    `}
  `}
`;
